
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lead-generation-sydney",
      function () {
        return require("private-next-pages/lead-generation-sydney.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lead-generation-sydney"])
      });
    }
  